import KyMethod from "../repositories/KyMethod"

export default class BootcampRepositories extends KyMethod {
  async getRawBootcamp(type: "bootcamp" | "pro_class" | "coding_camp" | string, limit = 6) {
    return this._getData("/schools", { type, limit })
  }
}
